module.exports = __webpack_public_path__ + "static/img/gobang.3d7d944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/gobang.png
// module id = zYLj
// module chunks = 1